import { ProjectOverviewPage } from "@/components/projects/project-overview";
import { createFileRoute, useLoaderData } from "@tanstack/react-router";

/**
 * `/projects/:slug` overview — the default project sub-route. The
 * project header + tabs live in the `projects.$slug` layout; this
 * renders the body from `@/components/projects/project-overview`,
 * which the GitLab-native `/{group}/{project}` route reuses too.
 */
export const Route = createFileRoute("/_app/projects/$slug/")({
  component: ProjectOverviewRoute,
});

function ProjectOverviewRoute() {
  const layout = useLoaderData({ from: "/_app" });
  const data = useLoaderData({ from: "/_app/projects/$slug" });
  // Customer accounts don't have an Overview tab — bounce them
  // straight into Work Items, which is their primary surface.
  if (layout.isCustomer) {
    globalThis.location.replace(`/projects/${data.project.slug}/work-items`);
    return null;
  }
  return <ProjectOverviewPage data={data} />;
}
